import { cn } from "@/lib/utils";
import { Check, Loader2, X } from "lucide-react";
import { ms } from "@/lib/api";

const STAGES = [
  { key: "queued", label: "I kø" },
  { key: "intake", label: "Mottak" },
  { key: "analyzing_images", label: "Analyse" },
  { key: "optimizing_images", label: "Optimalisering" },
  { key: "quality_review", label: "Fidelity-kontroll" },
  { key: "staging", label: "Styling" },
  { key: "building_listing", label: "Annonseutkast" },
  { key: "completed", label: "Ferdig" },
];

/** Numbered stepper (DigiHome pattern): done = black circle with check, active = black outline, upcoming = gray. */
export const JobStageStepper = ({ stage, status, durations = {} }) => {
  const failed = status === "failed";
  const idx = STAGES.findIndex((s) => s.key === stage);
  const current = failed ? -1 : idx;
  return (
    <ol className="flex flex-wrap items-center gap-x-1 gap-y-2" data-testid="job-stage-stepper">
      {STAGES.map((s, i) => {
        const done = status === "completed" || current > i;
        const active = current === i && status !== "completed";
        const isFail = failed && i === idx;
        const dur = durations[s.key];
        return (
          <li key={s.key} className="flex items-center gap-1">
            <div className="flex items-center gap-2 pr-1" data-testid={`stage-${s.key}`}>
              <span className={cn("h-6 w-6 rounded-full flex items-center justify-center text-[11px] font-bold border",
                done ? "bg-primary text-primary-foreground border-primary" : active ? "border-primary text-primary" : isFail ? "surface-danger" : "border-border text-muted-foreground")}>
                {done ? <Check className="h-3 w-3" /> : active ? <Loader2 className="h-3 w-3 animate-spin" /> : isFail ? <X className="h-3 w-3" /> : i + 1}
              </span>
              <span className={cn("text-xs", done || active ? "font-semibold" : "text-muted-foreground")}>{s.label}</span>
              {dur != null && <span className="font-mono text-[10px] text-muted-foreground">{ms(dur)}</span>}
            </div>
            {i < STAGES.length - 1 && <span className={cn("h-px w-4", done ? "bg-primary" : "bg-border")} />}
          </li>
        );
      })}
    </ol>
  );
};
